<script>
export default {
    name: 'IlluProgression',
    props: {
        primaryColor: {
            type: String,
            default: '#31A4A7'
        },

        secondaryColor: {
            type: String,
            default: '#313132'
        },
    }
}
</script>
<template>
    <svg
        class="base-illu illu-progression"
        width="64"
        height="64"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <g fill="none" fill-rule="evenodd">
            <path
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="round"
                d="M13 25l12.5-12.5L38 25 55 9"
            />
            <path
                :stroke="secondaryColor" class="secondary-color"
                stroke-linecap="round"
                stroke-linejoin="round"
                d="M55 17V9h-8M9.5 55h45"
            />
            <path
                d="M22 44v8h-6v-8h6zm26-16v24h-6V28h6zm-13 8v16h-6V36h6z"
                :fill="primaryColor" class="primary-color"
            />
        </g>
    </svg>
</template>
